/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
      res=''
      if( window.customer.isLogIn){
    var comparing =
            Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<b class="excluding-vat">' + formatPrice(price) + '</b>';
    res += '<b class="including-vat">' + formatPrice(price * 1.21) + '</b>';
    if (comparing) {
      res +=
              ' <span class="ais-hit--price-striked excluding-vat"><span>' +
              formatPrice(compare_at_price) +
              '</span></span> ';
      res +=
              ' <span class="ais-hit--price-striked including-vat"><span>' +
              formatPrice(compare_at_price * 1.21) +
              '</span></span> ';
      res +=
              ' <span class="ais-hit--price-discount" style="font-weight: ' +
              Math.floor(discount_ratio * 10) * 100 +
              ';">-' +
              Math.floor(discount_ratio * 100) +
              '%</span>';
    }

      }
    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
            text,
            render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
     var inventory_quantity = this.inventory_quantity;

        var quantity_level = "";
        var stock_level_translation = "";

        if (inventory_quantity > 21) {
            quantity_level = " product-form__availability available HIGH";

            stock_level_translation = "In stock";
        } else {
            if (inventory_quantity > 5) {
                quantity_level = "product-form__availability available MEDIUM";
                stock_level_translation = "Medium stock ";
            } else {
                if (inventory_quantity > 0) {
                    quantity_level = "product-form__availability available LOW";
                    stock_level_translation = "Low stock";
                }
            }
        }
        var text = '';
        if( window.customer.isLogIn) {
            if (this.inventory_available) {
                text = "<div class='" + quantity_level + "'>" +
                    "<svg focusable=\"false\" class=\"icon icon--check\" viewBox=\"0 0 24 24\" role=\"presentation\">\n" +
                    "        <path fill=\"currentColor\" d=\"M9 20l-7-7 3-3 4 4L19 4l3 3z\"></path>\n" +
                    "    </svg>" +
                    "            <span>" + stock_level_translation + "</span>" +
                    "        </div>"
            } else {
                text = "<div class='product-form__availability not_available'>" +
                    "<svg focusable=\"false\" class=\"icon icon--close\" viewBox=\"0 0 19 19\" role=\"presentation\">\n" +
                    "        <path d=\"M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z\" fill=\"currentColor\" fill-rule=\"evenodd\"></path>\n" +
                    "    </svg>" +
                    "            <span>Sold out</span>" +
                    "        </div>"
            }
        }
        return formattedPriceWithComparison(
            this.price,
            this.compare_at_price,
            this.price_ratio
        ) + text;
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
              '/products/' +
              this.handle +
              (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
              !this._distinct &&
              this.variant_title &&
              this.variant_title !== 'Default Title' &&
              this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    getQualityLabel: function getQualityLabel() {
      var res = '';
      const qualityLabel = "Quality";
      this.tags.forEach(function(tag) {
        if (tag.includes("_quality")) {
          res = '<span class="quality-tag-search--container ">' + qualityLabel + ': <span class="quality-tag-search--container-quality">' + tag.split("|")[1] + '</span></span>';
        }
      })
      return res;
    },
    getQualityImage: function getQualityTag() {
      var res = '';

      const qualityTagURLs = {
        "oem": '//4phones.eu/cdn/shop/t/63/assets/oem.svg?v=39338390834503468181688654107',
        "oled-hard": '//4phones.eu/cdn/shop/t/63/assets/oled-hard.svg?v=17187964205039847041688654106',
        "oled-soft": '//4phones.eu/cdn/shop/t/63/assets/oled-soft.svg?v=76199577378248556931688654105',
        "original": '//4phones.eu/cdn/shop/t/63/assets/original.svg?v=142012892228613106441688654104',
        "pulled": '//4phones.eu/cdn/shop/t/63/assets/pulled.svg?v=162953084065242624921688654109',
        "refurbished": '//4phones.eu/cdn/shop/t/63/assets/refurbished.svg?v=18176436923164317931688654105',
        "compatible": '//4phones.eu/cdn/shop/t/63/assets/compatible.svg?v=102944788720466574071688654100',
        "in-cell": '//4phones.eu/cdn/shop/t/63/assets/in-cell.svg?v=112697631118794926801688654107',
        "premium": '//4phones.eu/cdn/shop/t/63/assets/premium.svg?v=11949894487248429261688654109',
      }

      this.tags.forEach(function(tag) {
        if (tag.includes("_quality")) {
          console.log(tag.split("|")[1].toLowerCase());
          res = '<span class="quality-tag--container"><img class="quality-tag--image" src="' + qualityTagURLs[tag.split("|")[1].toLowerCase()] + '"/></span>';
        }
      })

      return res;
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
                this._highlightResult.title.value
        );
      }

      if (
              !this._distinct &&
              this.variant_title &&
              this.variant_title !== 'Default Title' &&
              this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
              .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
                this._highlightResult.title.value
        );
      }

      if (
              !this._distinct &&
              this.variant_title &&
              this.variant_title !== 'Default Title' &&
              this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
              this._highlightResult.product_type &&
              this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
                this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
                this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return '//4phones.eu/cdn/shop/files/Place_Holder_Image_-_EU_Store..png?v=1787119450';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return '//4phones.eu/cdn/shop/files/Place_Holder_Image_-_EU_Store..png?v=1787119450';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
          {},
          algolia.helpers,
          algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
